import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('base-changes', storeModule.createStoreModule('base-changes'))
